import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { useLastLocation } from 'react-router-last-location';
import cn from 'classnames';
import './UserLookbookHeader.scss';

import { getUserId, getOpportunityRequestWithAutoSendLookbookId } from '../../../Helpers/user_helpers';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { faEdit } from '@fortawesome/pro-light-svg-icons';
import commaNumber from 'comma-number';
import { getLookbookCurrencySymbol } from '../../../Helpers/lookbook_helpers';

const UserLookbookHeader = props => {
  const { lookbook, userHasAlreadyOrdered, user } = props;
  const { coverImage, title, price_limit, item_limit } = lookbook;
  const userIsOnPlatform = getUserId(user);

  const history = useHistory();
  const lastLocation = useLastLocation();
  const isLookbookFromUndecidedOpportunityRequest = getOpportunityRequestWithAutoSendLookbookId(user, lookbook.id);
  const showPriceLimitBlock = !!price_limit;
  const showItemLimitBlock = !!item_limit;
  const currencyDisplay = getLookbookCurrencySymbol(lookbook);

  let headBack, headBackLabel;
  if (isLookbookFromUndecidedOpportunityRequest) {
    const path = `/opportunity/${isLookbookFromUndecidedOpportunityRequest.Opportunity_id}`;
    headBack = () => (lastLocation?.pathname === path ? history.goBack() : history.push(path));
    headBackLabel = 'back to opportunity';
  } else if (lastLocation?.pathname?.includes('/partners')) {
    headBack = () => history.goBack();
    headBackLabel = 'back to my gifting portal';
  } else if (lastLocation?.pathname?.includes('/opportunity')) {
    headBack = () => history.goBack();
    headBackLabel = 'back to opportunity';
  } else {
    headBack = () => history.push('/partners/gifting');
    headBackLabel = 'back to my gifting portal';
  }

  return (
    <div className={cn('user-lookbook-header-outer', { 'has-cover-image': !!coverImage })}>
      {coverImage && <img className='cover-image' alt='cover' src={coverImage} />}
      {coverImage && <div className='cover-image-background'></div>}
      <div className={cn('user-lookbook-header-inner', { 'has-cover-image': !!coverImage })}>
        <div className={cn('text-container', { userHasAlreadyOrdered })}>
          <div id='backlink-and-title'>
            {userIsOnPlatform && (
              <div className='backlink'>
                <FontAwesomeIcon icon={faArrowLeft} />
                <div onClick={headBack}>{headBackLabel}</div>
              </div>
            )}
            <div className='lookbook-title'>{title}</div>
          </div>
          <div className='price-and-item-limit'>
            {showPriceLimitBlock && (
              <div className='price-limit'>
                <div className='limit-content'>
                  <span>{`${currencyDisplay}${commaNumber(price_limit)}`}</span>
                </div>
                <div className='limit-label'>Price Limit</div>
              </div>
            )}
            {showItemLimitBlock && (
              <div className='item-limit'>
                <div className='limit-content'>
                  <>
                    {item_limit} {item_limit === 1 ? 'Item' : 'Items'}
                  </>
                </div>
                <div className='limit-label'>Item Limit</div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

UserLookbookHeader.propTypes = {
  lookbook: PropTypes.object.isRequired,
  userHasAlreadyOrdered: PropTypes.bool.isRequired,
  user: PropTypes.object.isRequired
};

export default UserLookbookHeader;
